import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_antd@3.0.0-beta.7@antd/es/collapse/index.js
// module id = 459
// module chunks = 0